{
  "moreActions": "Mai multe acțiuni"
}
